import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@core/environment/environment.service';
import {Observable} from 'rxjs';
import {TtsRequestModel} from '@core/modules/rest/text-to-speech/request/tts-request.model';

@Injectable()
export class TtsRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/tts';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getTTS(ttsObject: TtsRequestModel): Observable<string> {
        return this.httpClient.post<string>(this.controllerUrl.concat('/read'), ttsObject);
    }
}
